import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import getTaskManagementDefaultValues from 'utils/formHelpers/getTaskManagmentDefaultValues';
import { createTaskFormSchema } from 'utils/validators';

import type { TTaskManagementSchema } from 'utils/validators';
import type IUseCreateTaskForm from '../interfaces/IUseCreateTaskForm';

const useCreateTaskForm = ({ itemData, typeModal }: IUseCreateTaskForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading, errors },
    reset,
    setError,
    getValues,
    watch,
    setValue,
  } = useForm<TTaskManagementSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(createTaskFormSchema),
    values: getTaskManagementDefaultValues({ itemData, typeModal }),
  });

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    reset,
    errors,
  };
};

export default useCreateTaskForm;
